<div class="legal-page">
  <div class="legal-container">
    <div class="legal-header">
      <h1>{{ 'termsOfService.title' | translate }}</h1>
      <p class="last-updated">{{ 'legal.lastUpdated' | translate }}: {{ lastUpdated }}</p>
    </div>

    <div class="legal-content">
      <h2>{{ 'termsOfService.section1.title' | translate }}</h2>
      <p>{{ 'termsOfService.section1.content' | translate }}</p>

      <div class="highlight-box">
        <p>
          <strong>{{ 'termsOfService.section1.importantLabel' | translate }}:</strong> {{ 'termsOfService.section1.importantText' | translate }}
        </p>
      </div>

      <h2>{{ 'termsOfService.section2.title' | translate }}</h2>
      <p>{{ 'termsOfService.section2.intro' | translate }}</p>
      <ul>
        <li>{{ 'termsOfService.section2.item1' | translate }}</li>
        <li>{{ 'termsOfService.section2.item2' | translate }}</li>
        <li>{{ 'termsOfService.section2.item3' | translate }}</li>
        <li>{{ 'termsOfService.section2.item4' | translate }}</li>
        <li>{{ 'termsOfService.section2.item5' | translate }}</li>
        <li>{{ 'termsOfService.section2.item6' | translate }}</li>
      </ul>

      <h2>{{ 'termsOfService.section3.title' | translate }}</h2>
      <h3>{{ 'termsOfService.section3.sub1Title' | translate }}</h3>
      <p>{{ 'termsOfService.section3.sub1Content' | translate }}</p>

      <h3>{{ 'termsOfService.section3.sub2Title' | translate }}</h3>
      <p>{{ 'termsOfService.section3.sub2Content' | translate }}</p>

      <h2>{{ 'termsOfService.section4.title' | translate }}</h2>
      <p>{{ 'termsOfService.section4.intro' | translate }}</p>
      <ul>
        <li>{{ 'termsOfService.section4.item1' | translate }}</li>
        <li>{{ 'termsOfService.section4.item2' | translate }}</li>
        <li>{{ 'termsOfService.section4.item3' | translate }}</li>
        <li>{{ 'termsOfService.section4.item4' | translate }}</li>
        <li>{{ 'termsOfService.section4.item5' | translate }}</li>
        <li>{{ 'termsOfService.section4.item6' | translate }}</li>
        <li>{{ 'termsOfService.section4.item7' | translate }}</li>
      </ul>

      <h2>{{ 'termsOfService.section5.title' | translate }}</h2>
      <h3>{{ 'termsOfService.section5.sub1Title' | translate }}</h3>
      <p>{{ 'termsOfService.section5.sub1Content' | translate }}</p>

      <h3>{{ 'termsOfService.section5.sub2Title' | translate }}</h3>
      <p>{{ 'termsOfService.section5.sub2Content' | translate }}</p>

      <h3>{{ 'termsOfService.section5.sub3Title' | translate }}</h3>
      <p>{{ 'termsOfService.section5.sub3Content' | translate }}</p>

      <h2>{{ 'termsOfService.section6.title' | translate }}</h2>
      <p>{{ 'termsOfService.section6.intro' | translate }}</p>
      <ul>
        <li>{{ 'termsOfService.section6.item1' | translate }}</li>
        <li>{{ 'termsOfService.section6.item2' | translate }}</li>
        <li>{{ 'termsOfService.section6.item3' | translate }}</li>
        <li>{{ 'termsOfService.section6.item4' | translate }}</li>
      </ul>

      <h2>{{ 'termsOfService.section7.title' | translate }}</h2>
      <p>{{ 'termsOfService.section7.content' | translate }}</p>

      <h2>{{ 'termsOfService.section8.title' | translate }}</h2>
      <p>{{ 'termsOfService.section8.content' | translate }}</p>

      <h2>{{ 'termsOfService.section9.title' | translate }}</h2>
      <p>{{ 'termsOfService.section9.content' | translate }}</p>

      <h2>{{ 'termsOfService.section10.title' | translate }}</h2>
      <p>{{ 'termsOfService.section10.content' | translate }}</p>

      <h2>{{ 'termsOfService.section11.title' | translate }}</h2>
      <p>{{ 'termsOfService.section11.content' | translate }}</p>

      <h2>{{ 'termsOfService.section12.title' | translate }}</h2>
      <p>{{ 'termsOfService.section12.content' | translate }}</p>

      <div class="contact-info">
        <h3>{{ 'legal.contactUs' | translate }}</h3>
        <p>{{ 'termsOfService.contactIntro' | translate }}</p>
        <p>
          <strong>{{ 'legal.email' | translate }}:</strong> legal&#64;horseloop.com<br>
          <strong>{{ 'legal.address' | translate }}:</strong> HorseLoop AS, Oslo, Norway
        </p>
      </div>
    </div>
  </div>
</div>
